import {useMemo} from 'react';

import {RunsQueryContext} from '../../../state/runs/context';
import {Key} from '../../../util/runTypes';
import * as TableCols from '../../../util/tablecols';

export const useDefaultKeys = (
  defaultKeys: Key[] | undefined,
  sweep: RunsQueryContext['sweep']
) => {
  return useMemo(() => {
    if (defaultKeys) {
      return defaultKeys;
    }
    if (!sweep) {
      return TableCols.DEFAULT_RUNSELECTOR_KEYS;
    }
    if (sweep.earlyTerminate) {
      return TableCols.DEFAULT_SWEEP_EARLY_TERMINATE_KEYS;
    }
    return TableCols.DEFAULT_SWEEP_KEYS;
  }, [defaultKeys, sweep]);
};
